<template>
  <div class="settings-sms">
    <b-card no-body class="py-3">
      <b-card-body class="pt-0">
        <!-- <b-overlay
          :show="overlay_show"
          rounded="sm"
          variant="mid-primary"
          opacity="0.5"
          blur="2px"
        > -->
        <div class="row">
          <div class="col-md-12">
            <download-csv
              class="
                btn btn-bumblebee btn-mid btn-filter btn-mid-primary
                m-0
                float-right
              "
              :data="rowsData"
              :fields="fields"
              :labels="labels"
              name="SMS.csv"
            >
              <font-awesome-icon icon="fa-solid fa-download" class="mr-1" />
              Export CSV
            </download-csv>
            <button
              type="button"
              id=""
              class="
                btn btn-bumblebee btn-mid btn-filter btn-mid-info
                m-0
                mx-1
                float-right
              "
              @click="clickAddSMS"
            >
              + Add new
            </button>
          </div>
          <div class="col-md-12">
            <!-- <div class="card mt-1">
                <div class="card-body"> -->
            <b-table-simple
              class="table table-no-bordered table-hover myIrishDateTable"
              id="smsTable"
              hover
              responsive
            >
              <b-thead>
                <b-tr>
                  <b-th>Date & Time</b-th>
                  <b-th>Category</b-th>
                  <b-th>Status</b-th>
                  <b-th>Previously Sent </b-th>
                  <b-th>SMS Fees</b-th>
                  <b-th>Actions</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in rowsData" :key="item.id">
                  <b-td>{{ item.date }}</b-td>
                  <b-td>{{ item.category }}</b-td>
                  <b-td
                    ><span
                      class="dataStatusSpan"
                      v-bind:class="{
                        smsSentStatus: item.status == 'Sent',
                        smsNotSentStatus: item.status == 'Not sent',
                      }"
                    >
                      {{ item.status }}
                    </span></b-td
                  >
                  <b-td>{{ item.previously_sent }}</b-td>
                  <b-td>{{ item.sms_fees }}</b-td>

                  <b-td class="">
                    <b-button
                      variant="action"
                      class="mb-1"
                      @click="viewSMS(item.id)"
                      ><img
                        src="@/assets/images/my-irish-date/view-action-icon.png"
                        alt="mid icon" /></b-button
                  ></b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <!-- </div>
              </div> -->
          </div>
        </div>
        <!-- </b-overlay> -->
      </b-card-body>
    </b-card>
    <!-- add sms modal-->
    <b-modal
      id="addSMSModal"
      centered
      modal-class="modal-irish-date"
      hide-footer
    >
      <template #modal-title> Add New SMS</template>
      <div class="d-block mb-4"></div>
      <b-form @submit.prevent="onSubmitAddSMS">
        <b-row class="mt-3">
          <b-col md="12">
            <b-form-group
              label="SMS Title"
              label-for="sms_title"
              :sms_title="sms_title"
              label-class="form-label-mid"
            >
              <b-form-input
                id="sms_title"
                v-model="sms_title"
                :sms_title="sms_title"
                class="form-control-mid"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              class="form-group-v-select-irishdate"
              id=""
              label="SMS category (optional)"
              label-for="sms_category"
              :sms_category="sms_category"
              label-class="form-label-mid"
            >
              <p class="error_validation_message_p" v-if="invalid_sms_category">
                Please select category
              </p>
              <v-select
                :options="sms_categories"
                name="sms_category"
                title="sms_category"
                v-model="sms_category"
                :reduce="(item) => item.code"
                placeholder="Select category"
                required
              ></v-select
            ></b-form-group>
          </b-col>
        </b-row>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              label="SMS Context"
              label-for="sms_context"
              :sms_context="sms_context"
              label-class="form-label-mid"
            >
              <b-form-textarea
                id="sms_context"
                v-model="sms_context"
                :sms_context="sms_context"
                class="form-control-mid"
                rows="3"
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              class="form-group-v-select-irishdate"
              id="smsSendToFormGroup"
              label="Send to"
              label-for="send_to"
              :send_to="send_to"
              label-class="form-label-mid"
            >
              <p class="error_validation_message_p" v-if="invalid_send_to">
                Please select send to
              </p>
              <v-select
                :options="send_to_options"
                name="send_to"
                title="send_to"
                v-model="send_to"
                :reduce="(item) => item.code"
                placeholder="Select user(s)"
                required
              ></v-select
            ></b-form-group>
          </b-col>
        </b-row>
        <b-row> </b-row>
        <!-- <template class="justify-content-center mt-5" #modal-footer> -->
        <b-row class="justify-content-center w-100 mt-5">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="submit"
              variant="mid-primary"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              v-if="!is_loading"
            >
              Save
            </b-button>
            <b-button
              type="submit"
              disabled
              variant="mid-primary"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              variant="mid-danger-outline"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              @click="closeModal('addSMSModal')"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
        <!-- </template> -->
      </b-form>
    </b-modal>
    <!-- end add modal -->
    <!-- view modal -->
    <b-modal
      id="viewSMSModal"
      centered
      modal-class="modal-irish-date"
      hide-footer
    >
      <template #modal-title> SMS Info</template>

      <b-row class="mt-5">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">SMS title</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_title }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">SMS category</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_category }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">SMS context</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_context }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">Send to</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ send_to }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">Date & Time</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_date_time }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">Status</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">
            <span
              class="dataStatusSpan"
              v-bind:class="{
                smsSentStatus: sms_status == 'Sent',
                smsNotSentStatus: sms_status == 'Not sent',
              }"
            >
              {{ sms_status }}
            </span>
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">Previously sent </label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_previously_sent }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="3" md="4">
          <label class="form-label-mid label-info-mid">SMS fees</label>
        </b-col>
        <b-col lg="9" md="8">
          <p class="info-value-mid">{{ sms_fees }}</p>
        </b-col>
      </b-row>

      <b-row> </b-row>
      <!-- <template class="justify-content-center mt-5" #modal-footer> -->
      <b-row class="justify-content-center w-100 my-3">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="mid-danger-outline"
            class="w-100 btn-bumblebee btn-mid btn-mid-submit"
            @click="closeModal('viewSMSModal')"
          >
            Close
          </b-button>
        </b-col>
      </b-row>
      <!-- </template> -->
    </b-modal>
    <!-- end view modal-->
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import JsonCSV from "vue-json-csv";

export default {
  name: "MIDSettingsSMS",
  components: { downloadCsv: JsonCSV },
  data() {
    return {
      overlay_show: false,
      rowsData: [
        {
          id: 1,
          date: " 20-06-2020 12:30 ",
          category: "Promo",
          status: "Sent",
          previously_sent: 2,
          sms_fees: '$20',
        },
        {
          id: 2,
          date: "20-06-2020 14:30",
          category: "Promo",
          status: "Not sent",
          previously_sent: 2,
          sms_fees: '$20',
        },
        {
          id: 3,
          date: "22-06-2020 12:30",
          category: "Premium",
          status: "Sent",
          previously_sent: 3,
          sms_fees: '$30',
        },
        {
          id: 4,
          date: "21-06-2020 12:30",
          category: "Payment",
          status: "Not sent",
          previously_sent: 3,
          sms_fees: '$30',
        },
        {
          id: 5,
          date: "23-06-2020 12:30",
          category: "Valentine’s day",
          status: "Sent",
          previously_sent: 5,
          sms_fees: '$50',
        },
      ],
      columns: [
        {
          label: "Date & Time",
          key: "date",
          data: "date",
          class: "dateTimeTd",
        },
        { label: "Category", key: "category", data: "category" },
        { label: "Status", key: "status", data: "status", class: "centerTd" },
        {
          label: "Previously Sent",
          key: "previously_sent",
          data: "previously_sent",
          class: "centerTd",
        },
        {
          label: "SMS Fees",
          key: "sms_fees",
          data: "sms_fees",
          class: "centerTd",
        },
        { label: "Actions", key: "actions", class: "centerTd test" },
      ],
      labels: {
        id: "ID",
        date: "Date & Time",
        category: "Category",
        status: "Status",
        previously_sent: "Previously Sent",
        sms_fees: "SMS Fees",
      },
      fields: [
        "id",
        "date",
        "category",
        "status",
        "previously_sent",
        "sms_fees",
      ],

      is_loading: false,
      sms_title: null,
      sms_category: null,
      invalid_sms_category: null,
      sms_categories: [
        { label: "Promo", code: "Promo" },
        { label: "Valentine’s day", code: "ValentineDay" },
        { label: "Premium", code: "Premium" },
        { label: "Payment", code: "Payment" },
      ],
      sms_context: null,
      send_to: null,
      invalid_send_to: false,
      send_to_options: [
        { label: "Members only", code: "members" },
        { label: "All users", code: "all_users" },
      ],
      sms_date_time: null,
      sms_status: null,
      sms_previously_sent: null,
      sms_fess: null,
    };
  },
  mounted() {
    // this.overlay_show = true;
    this.initTable();
  },
  methods: {
    initTable() {
      $("#smsTable").DataTable({
        // sDom: 'flti<"table_selected_rows">p',
        // buttons: [
        //    'csv',
        // ],
        ordering: false,
        info: true,
        destroy: true,
        // responsive: true,
        // scrollY: "450px",
        // scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [10, 25, 50, 100, -1],
          [10, 25, 50, 100, "All"],
        ],
        columnDefs: [
          // Center align the header content of column 1
          { className: "dt-head-center", targets: [2, 3, 4, 5] },
        ],
        columns: this.columns,
        // data: this.$parent.rowsData,
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
      });
    },
    clickAddSMS() {
      console.log("click add sms");

      this.sms_title = null;
      this.sms_category = null;
      this.sms_context = null;
      this.send_to = null;

      this.$root.$emit("bv::show::modal", "addSMSModal");
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    onSubmitAddSMS() {
      console.log("submit add sms ");
      console.log(this.sms_title);
      console.log(this.sms_category);
      console.log(this.sms_context);
      console.log(this.send_to);

      this.$bvModal.hide("addSMSModal");
      this.$fire({
        // title: "Title",
        text: "SMS is created successfully",
        type: "success",
        timer: 3000,
      }).then((r) => {
        // console.log(r.value);
      });
    },
    viewSMS(id) {
      this.$root.$emit("bv::show::modal", "viewSMSModal");
      this.sms_title = "title sms test";
      this.sms_category = "Promo";
      this.sms_context =
        "test sms - context test sms - context test sms - context test sms - context test sms - context test sms - context";
      this.send_to = "members";
      this.sms_date_time = "23-06-2022 12:30";
      this.sms_status = "Sent";
      this.sms_previously_sent = 5;
      this.sms_fees = "$50";
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/settings/SMS.vue